export const MEMBERS_FIELD = 'members_with_access'

export const getDefaultValues = () => ({
  [MEMBERS_FIELD]: [],
})
